module.exports = __webpack_public_path__ + "static/img/putong.0ccfe88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/putong.png
// module id = 9RWm
// module chunks = 3